import React, { useState, useRef } from 'react';
import TEXT from '../constants/text';
/* taskbar component */

const Taskbar = ({ openWindows, onWindowClick, onWindowClose, onCloseAll, openWindowCount, projectDetailData, experienceDetailData }) => {
  const [showTimeDropdown, setShowTimeDropdown] = useState(false);
  const dropdownRef = useRef(null);
  /* state for time dropdown visibility */

  const getCurrentTime = () => {
    const now = new Date();
    return now.toLocaleTimeString('en-US', { 
      hour: '2-digit', 
      minute: '2-digit',
      hour12: false 
    });
    /* get current time in 24hr format */
  };

  const handleTimeClick = () => {
    if (showTimeDropdown) {
      // already open, do nothing (cooldown)
      return;
    } else {
      setShowTimeDropdown(true);
      // auto-hide after 2 seconds
      setTimeout(() => {
        setShowTimeDropdown(false);
      }, 2000);
    }
    /* handle time dropdown with cooldown and auto-fade */
  };



  return (
    <div className="taskbar">
      {/* start button */}
      <div className="start-button">
        <img 
          src="/assets/windows97logo.svg" 
          alt="Windows" 
          className="start-logo"
        />
        <span className="start-text">{TEXT.TASKBAR.START}</span>
      </div>
      {/* classic xp start button with windows logo - no interaction */}
      
      {/* linkedin button */}
      <a 
        href={TEXT.SOCIAL.LINKEDIN} 
        target="_blank" 
        rel="noopener noreferrer"
        className="linkedin-button"
      >
        <img 
          src="/assets/linkedPixel.svg" 
          alt="LinkedIn" 
          className="linkedin-icon"
        />
      </a>
      {/* pixelated linkedin button */}
      
      {/* github button */}
      <a 
        href={TEXT.SOCIAL.GITHUB} 
        target="_blank" 
        rel="noopener noreferrer"
        className="github-button"
      >
        <img 
          src="/assets/pixelGitHub.png" 
          alt="GitHub" 
          className="github-icon"
        />
      </a>
      {/* pixelated github button */}
      
      {/* email button */}
      <button className="email-button" onClick={() => onWindowClick('email')}>
        <span className="email-icon">✉</span>
      </button>
      {/* email button - opens email window */}
      
      
      {/* quick launch area */}
      <div className="quick-launch">
        {/* add quick launch icons here if needed */}
      </div>
      {/* space for quick launch icons */}
      
      {/* taskbar items */}
      <div className="taskbar-items">
        {Object.entries(openWindows).map(([windowName, isOpen]) => {
          if (!isOpen) return null;
          
          const windowTitles = {
            about: TEXT.WINDOW_TITLES.ABOUT,
            skills: TEXT.WINDOW_TITLES.SKILLS,
            repositories: TEXT.WINDOW_TITLES.REPOSITORIES,
            environments: TEXT.WINDOW_TITLES.ENVIRONMENTS,
            email: TEXT.WINDOW_TITLES.EMAIL,
            projects: TEXT.WINDOW_TITLES.PROJECTS,
            experience: TEXT.WINDOW_TITLES.EXPERIENCE,
            education: TEXT.WINDOW_TITLES.EDUCATION,
            projectDetail: projectDetailData ? TEXT.WINDOW_TITLES.PROJECT_DETAIL(projectDetailData.title) : TEXT.WINDOW_TITLES.PROJECT_DETAIL_FALLBACK,
            experienceDetail: experienceDetailData ? TEXT.WINDOW_TITLES.EXPERIENCE_DETAIL(experienceDetailData.title) : TEXT.WINDOW_TITLES.EXPERIENCE_DETAIL_FALLBACK
          };
          
          return (
            <div 
              key={windowName}
              className="taskbar-item"
              onClick={() => onWindowClick(windowName)}
            >
              <span className="taskbar-text">{windowTitles[windowName]}</span>
              <button 
                className="taskbar-close"
                onClick={(e) => {
                  e.stopPropagation();
                  onWindowClose(windowName);
                }}
              >
                ×
              </button>
            </div>
          );
        })}
        
        {/* close all button - only show when 2+ windows are open */}
        {openWindowCount >= 2 && (
          <div className="close-all-button" onClick={onCloseAll}>
            <span className="close-all-text">{TEXT.TASKBAR.CLOSE_ALL}</span>
          </div>
        )}
        {/* close all button - windows xp style */}
      </div>
      
      {/* system tray */}
      <div className="system-tray">
        <div className="tray-icons">
          {/* system tray icons would go here */}
        </div>
        <div className="clock" onClick={handleTimeClick}>
          {getCurrentTime()}
        </div>
        {/* clickable time display */}
        
        {/* time dropdown */}
        {showTimeDropdown && (
          <div ref={dropdownRef} className="time-dropdown">
            <div className="time-dropdown-content">
              {TEXT.TASKBAR.TIME_DROPDOWN}
            </div>
          </div>
        )}
        {/* dropdown that slides out northward */}
      </div>
    </div>
  );
};

export default Taskbar;
